'use strict';

var DURATION_UNITS = require('./DURATION_UNITS');

module.exports = '((?:\\d+)?\\s*(?:' + DURATION_UNITS + '))s?';


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/range/var/FULL_CAPTURED_DURATION.js
// module id = 433
// module chunks = 1